import { computed } from 'vue';
import { get, mapValues, set } from 'lodash-es';
import { useI18n } from 'vue-i18n';

// eslint-disable-next-line max-params
export const useContent = (props, options, reference, configuration, phoneNumber, formattedTotalPrice) => {
  const { t } = useI18n();

  const content = computed(() => {
    const sections = { ...props.config.sections };
    sections.options.fieldsets = mapValues(sections.options.fieldsets, (fieldset, key) => ({
      ...fieldset,
      sublegend: fieldset.sublegend ?? get(options.value, [key, 'formattedPrice'], ''),
    }));
    set(sections, ['reference', 'fieldsets', 'reference', 'value'], reference.value ?? '');
    set(
      sections,
      ['reference', 'fieldsets', 'timepiece', 'value'],
      reference.value ? t(`EngravingTool.reference.${reference.value}`) : '',
    );
    set(
      sections,
      ['summary', 'fieldsets', 'pricing', 'label'],
      t('EngravingTool.summary.label', {
        engraving: get(options.value, ['engravings', 'items', configuration.value.engraving, 'label'], ''),
        timepiece: sections.reference.fieldsets.timepiece.value,
      }),
    );
    set(
      sections,
      ['summary', 'fieldsets', 'pricing', 'value'],
      get(options.value, ['engravings', 'items', configuration.value.engraving, 'formattedPrice'], ''),
    );

    const footer = { ...props.config.footer };
    set(footer, ['fieldsets', 'pricing', 'value'], formattedTotalPrice.value);

    return {
      configurator: {
        modals: props.config.modals,
        header: {
          phone: phoneNumber.value,
        },
        sections,
        footer,
        navigation: {
          label: t('EngravingTool.navigation.text'),
        },
      },
      validation: {
        valueMissing: t('EngravingTool.validation.valueMissing'),
        patternMismatch: t('EngravingTool.validation.patternMismatch'),
        tooManyLines: (n) => t('EngravingTool.validation.tooManyLines', { n }),
        tooManyCharsPerLine: (n) => t('EngravingTool.validation.tooManyCharsPerLine', { n }),
        tooManyChars: (n) => t('EngravingTool.validation.tooManyChars', { n }),
      },
      view: {
        closeText: t('Button.close'),
        overlapWarning: t('EngravingTool.validation.overlapping'),
        scaleWarning: t('EngravingTool.scaleWarning'),
        materialWarning: (origin, fallback) =>
          t('EngravingTool.materialWarning', {
            origin: t(`EngravingTool.material.${origin}`),
            fallback: t(`EngravingTool.material.${fallback}`),
          }),
        loadingError: t('EngravingTool.loadingError'),
      },
    };
  });

  return {
    content,
  };
};
